import React from 'react'
import {Input, NumberSelect} from '@sabre/spark-react'

const inputTextLayout = (locals) => {
    if (locals.typeInfo.type.is.name !== 'isNumber') {
        const options = {
            errorMessage: locals.hasError ? locals.error.props.children : null,
            onChange: (value) => locals.onChange(value),
            value: locals.value,
            disabled: locals.disabled,
            label: locals.label,
            type: locals.type,
            placeholder: locals.attrs.placeholder, // defect on spark on IE
            thinLabel: locals.attrs.thinLabel !== undefined
                ? locals.attrs.thinLabel
                : locals.typeInfo.isMaybe ? '(Optional)' : null,
            typeAheadFormat: locals.attrs.typeAheadFormat ? locals.attrs.typeAheadFormat : null,
            pattern: locals.attrs.pattern ? locals.attrs.pattern : null
        }
        return (
            <Input {...options} className="spark-mar-b-1"/>
        )
    }
    else {
        const options = {
            errorMessage: locals.hasError ? locals.error.props.children : null,
            onChange: (value) => locals.onChange(value),
            onClick: () => {
            },
            value: locals.value || locals.attrs.min,
            disabled: locals.disabled,
            label: locals.label,
            min: locals.attrs.min,
            max: locals.attrs.max,
            required: !locals.typeInfo.isMaybe
        }
        return (
            <NumberSelect {...options} onClick={() => {
            }} className="spark-mar-b-1"/>
        )
    }
}

export default inputTextLayout



// WEBPACK FOOTER //
// ./src/shared/components/tcomb/sparkInputLayout.js